var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2278 1.14286H5.7224C5.71187 1.14286 5.70251 1.14641 5.69272 1.14874V0.62785C5.69272 0.281625 5.39921 0 5.03836 0H0.654355C0.29351 0 0 0.281625 0 0.62785V6.48326C0 6.82949 0.29351 7.11111 0.654355 7.11111H1.42318V7.3946C1.42318 7.72843 1.70544 8 2.05252 8H6.2278C6.57488 8 6.85714 7.72843 6.85714 7.3946V1.74826C6.85714 1.41444 6.57488 1.14286 6.2278 1.14286ZM0.258754 6.48326V0.62785C0.258754 0.42175 0.436279 0.253975 0.654355 0.253975H5.03836C5.25644 0.253975 5.43396 0.42175 5.43396 0.62785V6.48326C5.43396 6.68936 5.25644 6.85715 5.03836 6.85715H0.654355C0.436279 6.85715 0.258754 6.68936 0.258754 6.48326ZM6.59838 7.3946C6.59838 7.58843 6.43211 7.74604 6.2278 7.74604H2.05252C1.84821 7.74604 1.68193 7.58843 1.68193 7.3946V7.11111H5.03836C5.39921 7.11111 5.69272 6.82949 5.69272 6.48326V1.39095C5.70251 1.39328 5.71187 1.39682 5.7224 1.39682H6.2278C6.43211 1.39682 6.59838 1.55444 6.59838 1.74826V7.3946Z",
    fill: "#686B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.de95fccb.svg";
export { ForwardRef as ReactComponent };